<div [formGroup]="ItemDates">
  <div class="tw-flex tw-flex-col tw-gap-1 tw-mt-5">
    <div class="tw-grid tw-grid-cols-2 tw-gap-4">

      <div class="sml-control-group tw-col-span-2" *ngIf="showDatesRadioButton()" [ngClass]="{'tablet:tw-col-span-2' : isRegistrationItem,
        'tablet:tw-col-span-1': !isRegistrationItem
      }">
        <label for="eventType" *ngIf="!isRegistrationItem" class="sml-new-label">Dates <sup class="tw-text-alert-800">*</sup></label>
        <div class="tw-flex max-md:tw-flex-col" [ngClass]="{'tablet:tw-items-center tw-gap-3': isRegistrationItem}">
        <div *ngIf="isRegistrationItem" class="sml-new-label">Event Dates (Optional)</div>
        <sml-radio-button
        formControlName="eventType"
        [options]="dateLevelEnum"
        (ngModelChange)="onEventTypeChange()"
        [tabView]="true"
        [isRegistrationItem]="isRegistrationItem"
      ></sml-radio-button>
      </div>

      </div>
      <div class="sml-control-group tw-col-span-1 max-md:tw-col-span-2" *ngIf="!isRegistrationItem"
      [ngClass]="{'tablet:!tw-col-span-2': !showDatesRadioButton(),
        'tablet:!tw-col-span-1':showDatesRadioButton()
      }">
        <label for="timeZone" class="sml-label">Event Time Zone <sup *ngIf="showMandatory || timeZoneMandatory" class="tw-text-alert-800">*</sup></label>
        <sml-search-dropdown #searchDropdownComponent formControlName="timeZone"  [position]="'bottom'" [items]="timeZones" (controlTouched)="onControlTouched()" (controlDirty)="onControlDirty()" [placeholder]="'Select Time Zone'" [isInvalid]="control['timeZone'].invalid && (control['timeZone'].dirty || control['timeZone'].touched)"></sml-search-dropdown>
        <div class="sml-form-error" *ngIf="control['timeZone'].invalid && (control['timeZone'].dirty || control['timeZone'].touched)">
          <p *ngIf="control['timeZone'].errors?.['required']" class="tw-text-alert-800">
           This field is mandatory.
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="tw-font-medium tw-text-sm tw-mb-2" id="tax-level-heading">
      Single Day Event or Multi Day?
    </div>

    <sml-radio-button
      formControlName="eventType"
      [options]="dateLevelEnum"
      (ngModelChange)="onEventTypeChange()"
      [tabView]="true"
    ></sml-radio-button> -->

    <!-- Render ng-container only if eventType has a value -->
    <ng-container *ngIf="ItemDates.get('eventType')?.value">
      <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-mt-5">
        <!-- Event Date -->
        <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1" [ngClass]="{'tablet:tw-col-span-2':ItemDates.get('eventType')?.value===dateLevelEnum['Single Day Event'] && isRegistrationItem}">
          <label for="eventStartDate" class="sml-label">
            Event <span *ngIf="ItemDates.get('eventType')?.value===
            dateLevelEnum['Multi Day Event']">Start</span> Date<sup class="tw-text-alert-800">*</sup>
          </label>
          <div class="tw-relative">
            <div
              (click)="onStartDate()"
              class="tw-sml-border tw-rounded-lg tw-flex tw-items-center tw-gap-2 tw-justify-between tw-py-[14px] tw-px-3"
              [ngClass]="{
                'sml-control-error':
                  control['eventStartDate'].invalid &&
                  (control['eventStartDate'].dirty ||
                    control['eventStartDate'].touched)
              }"
            >
              <div class="tw-flex-1">
                <input
                  class="tw-border-none tw-outline-none"
                  placeholder="MM/DD/YYYY"
                  formControlName="eventStartDate"
                  readonly
                />
              </div>

              <i-icon
                [name]="'calendar'"
                class="tw-text-mercury-600 !tw-w-4 !tw-h-4 tw-cursor-pointer"
              ></i-icon>
            </div>
            <div class="tw-left-0 tw-absolute tw-z-10" *ngIf="showStartdate">
              <sml-range-picker
                (smlClickOutside)="showStartdate = false"
                [hasSingleCalndar]="true"
                [hasSingleDatePicker]="true"
                [daysOfWeek]="['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']"
                [showClearButton]="false"
                [showApplyButton]="false"
                [showSelectedDates]="false"
                [selectedDate]="selectedStartDate"
                (selectedDateChange)="onDateChange($event)"
                [disablePastDates]="true"
              ></sml-range-picker>
            </div>
            <div
              class="sml-form-error"
              *ngIf="
                control['eventStartDate'].invalid &&
                (control['eventStartDate'].dirty ||
                  control['eventStartDate'].touched)
              "
            >
              <p
                *ngIf="control['eventStartDate'].errors?.['required']"
                class="tw-text-alert-800"
              >
                Event <span *ngIf="ItemDates.get('eventType')?.value===
            dateLevelEnum['Multi Day Event']">start</span> date is required.
              </p>
            </div>
    
          </div>
        </div>

        <ng-container
          *ngIf="
            ItemDates.get('eventType')?.value ===
            dateLevelEnum['Single Day Event'] && !isRegistrationItem
          "
        >
          <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
            <label for="event-time" class="sml-label"
              >Event Time (Start time/End time)</label
            >
            <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
              <div
                class="tw-sml-border tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-gap-2 tw-px-1 tw-w-full"
              >
                <input
                  class="tw-border-none tw-outline-none tw-w-3/4"
                  placeholder="hh:mm"
                  formControlName="startTime"
                  mask="00:00"
                  [ngClass]="{
                    'sml-control-error':
                      control['startTime'].invalid &&
                      (control['startTime'].dirty ||
                        control['startTime'].touched)
                  }"
                />

                <div
                  class="tw-flex tw-flex-col tw-items-center tw-text-mercury-600 tw-font-medium tw-text-sm hover:tw-cursor-pointer"
                 
                >
                  <i-icon
                    [name]="'arrow-up-thin'"
                    class="!tw-w-4! !tw-h-4"
                    (click)="toggleAMPM('start')"
                  ></i-icon>

                  <div >
                    {{ StartTimeAPM }}
                  </div>

                  <i-icon
                    [name]="'arrow-down-thin'"
                    class="!tw-w-4 !tw-h-4"
                    (click)="toggleAMPM('start')"
                  ></i-icon>
                </div>
              </div>

              <!-- End Time -->
              <div
                class="tw-sml-border tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-gap-2 tw-px-1 tw-w-full"
              >
                <input
                  class="tw-border-none tw-outline-none tw-w-3/4"
                  placeholder="hh:mm"
                  formControlName="endTime"
                  mask="00:00"
                  [ngClass]="{
                    'sml-control-error':
                      control['endTime'].invalid &&
                      (control['endTime'].dirty || control['endTime'].touched)
                  }"
                />
                <div
                  class="tw-flex tw-flex-col tw-items-center tw-text-mercury-600 tw-font-medium tw-text-sm hover:tw-cursor-pointer"
                 
                >
                  <i-icon
                    [name]="'arrow-up-thin'"
                    class="!tw-w-4 !tw-h-4"
                    (click)="toggleAMPM('end')"
                  ></i-icon>

                  <div  >
                    {{ EndTimeAPM }}
                  </div>

                  <i-icon
                    [name]="'arrow-down-thin'"
                    class="!tw-w-4 !tw-h-4"
                    (click)="toggleAMPM('end')"
                  ></i-icon>
                </div>
              </div>
            </div>
            @if( ItemDates.errors?.['endTimeLessThanStart']){
            <div class="tw-text-alert-800 sml-form-error">
              End time cannot be smaller than Start time
            </div>
            }
            @if( ItemDates.errors?.['endTimeEqualToStart']){
              <div class="tw-text-alert-800 sml-form-error">
                Start time cannot be equal to End Time 
              </div>
              }

            <div
              id="time-validation-error"
              class="tw-text-alert-800 sml-form-error"
              *ngIf="
                ((control['startTime']?.touched ||
                  control['startTime']?.dirty) &&
                  control['startTime']?.errors) ||
                ((control['endTime']?.touched || control['endTime']?.dirty) &&
                  control['endTime']?.errors)
              "
            >
              <ng-container
                *ngIf="
                  control['startTime']?.errors || control['endTime']?.errors
                "
              >
              Please enter time in correct format
              </ng-container>
            </div>
            <div
              class="tw-text-alert-800 sml-form-error"
              *ngIf="ItemDates?.errors"
            >
              <ng-container *ngIf="ItemDates?.errors?.['startTimeRequired']">
                Please enter Start time.
              </ng-container>
              <ng-container *ngIf="ItemDates?.errors?.['endTimeRequired']">
                Please enter End time.
              </ng-container>
             
            </div>
          </div>
        </ng-container>

        <ng-container
          *ngIf="
            ItemDates.get('eventType')?.value ===
            dateLevelEnum['Multi Day Event']
          "
        >
          <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
            <label for="eventEndDate" class="sml-label">
              Event End Date<sup class="tw-text-alert-800">*</sup>
            </label>
            <div class="tw-relative">
              <div
                (click)="onEndDate()"
                class="tw-sml-border tw-rounded-lg tw-flex tw-items-center tw-gap-2 tw-justify-between tw-py-[14px] tw-px-3"
                [ngClass]="{
                  'sml-control-error':
                    control['eventEndDate'].invalid &&
                    (control['eventEndDate'].dirty ||
                      control['eventEndDate'].touched)
                }"
              >
                <div class="tw-flex-1">
                  <input
                    class="tw-border-none tw-outline-none"
                    placeholder="MM/DD/YYYY"
                    formControlName="eventEndDate"
                    readonly
                  />
                </div>

                <i-icon
                  [name]="'calendar'"
                  class="tw-text-mercury-600 !tw-w-4 !tw-h-4 tw-cursor-pointer"
                ></i-icon>
              </div>
              <div class="tw-left-0 tw-absolute tw-z-10" *ngIf="showEndDate">
                <sml-range-picker
                  (smlClickOutside)="showEndDate = false"
                  [hasSingleCalndar]="true"
                  [hasSingleDatePicker]="true"
                  [daysOfWeek]="[
                    'Sun',
                    'Mon',
                    'Tue',
                    'Wed',
                    'Thu',
                    'Fri',
                    'Sat'
                  ]"
                  [showClearButton]="false"
                  [showApplyButton]="false"
                  [showSelectedDates]="false"
                  [selectedDate]="selectedEndDate"
                  (selectedDateChange)="onDateChange($event)"
                  [disablePastDates]="true"
                ></sml-range-picker>
              </div>
              <div
                class="sml-form-error"
                *ngIf="
                  control['eventEndDate'].invalid &&
                  (control['eventEndDate'].dirty ||
                    control['eventEndDate'].touched)
                "
              >
                <p
                  *ngIf="control['eventEndDate'].errors?.['required']"
                  class="tw-text-alert-800"
                >
                  Event end date is required.
                </p>
              </div>
             
              @if( ItemDates.errors?.['endDateLessThanStart']){
              <div class="tw-text-alert-800 sml-form-error">
                End date cannot be less than start date
              </div>
              }
              @if( ItemDates.errors?.['endDateEqualToStart']){
                <div class="tw-text-alert-800 sml-form-error">
                  Start date cannot be equal to End date 
                </div>
                }
            </div>
          </div>
        </ng-container>
      </div>
      <div class="tw-grid tw-grid-cols-2 tw-gap-4 " [ngClass]="{'tw-mt-5': isRegistrationItem}">
          <ng-container
          *ngIf="
            ItemDates.get('eventType')?.value ===
            dateLevelEnum['Single Day Event'] && isRegistrationItem
          "
        >
          <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
            <label for="event-time" class="sml-label"
              >Event Time (Start time/End time)</label
            >
            <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
              <div
                class="tw-sml-border tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-gap-2 tw-px-1 tw-w-full"
              >
                <input
                  class="tw-border-none tw-outline-none tw-w-3/4"
                  placeholder="hh:mm"
                  formControlName="startTime"
                  mask="00:00"
                  [ngClass]="{
                    'sml-control-error':
                      control['startTime'].invalid &&
                      (control['startTime'].dirty ||
                        control['startTime'].touched)
                  }"
                />

                <div
                  class="tw-flex tw-flex-col tw-items-center tw-text-mercury-600 tw-font-medium tw-text-sm hover:tw-cursor-pointer"
                 
                >
                  <i-icon
                    [name]="'arrow-up-thin'"
                    class="!tw-w-4! !tw-h-4"
                    (click)="toggleAMPM('start')"
                  ></i-icon>

                  <div >
                    {{ StartTimeAPM }}
                  </div>

                  <i-icon
                    [name]="'arrow-down-thin'"
                    class="!tw-w-4 !tw-h-4"
                    (click)="toggleAMPM('start')"
                  ></i-icon>
                </div>
              </div>

              <!-- End Time -->
              <div
                class="tw-sml-border tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-gap-2 tw-px-1 tw-w-full"
              >
                <input
                  class="tw-border-none tw-outline-none tw-w-3/4"
                  placeholder="hh:mm"
                  formControlName="endTime"
                  mask="00:00"
                  [ngClass]="{
                    'sml-control-error':
                      control['endTime'].invalid &&
                      (control['endTime'].dirty || control['endTime'].touched)
                  }"
                />
                <div
                  class="tw-flex tw-flex-col tw-items-center tw-text-mercury-600 tw-font-medium tw-text-sm hover:tw-cursor-pointer"
                 
                >
                  <i-icon
                    [name]="'arrow-up-thin'"
                    class="!tw-w-4 !tw-h-4"
                    (click)="toggleAMPM('end')"
                  ></i-icon>

                  <div  >
                    {{ EndTimeAPM }}
                  </div>

                  <i-icon
                    [name]="'arrow-down-thin'"
                    class="!tw-w-4 !tw-h-4"
                    (click)="toggleAMPM('end')"
                  ></i-icon>
                </div>
              </div>
            </div>
            @if( ItemDates.errors?.['endTimeLessThanStart']){
            <div class="tw-text-alert-800 sml-form-error">
              End time cannot be smaller than Start time
            </div>
            }
            @if( ItemDates.errors?.['endTimeEqualToStart']){
              <div class="tw-text-alert-800 sml-form-error">
                Start time cannot be equal to End Time 
              </div>
              }

            <div
              id="time-validation-error"
              class="tw-text-alert-800 sml-form-error"
              *ngIf="
                ((control['startTime']?.touched ||
                  control['startTime']?.dirty) &&
                  control['startTime']?.errors) ||
                ((control['endTime']?.touched || control['endTime']?.dirty) &&
                  control['endTime']?.errors)
              "
            >
              <ng-container
                *ngIf="
                  control['startTime']?.errors || control['endTime']?.errors
                "
              >
              Please enter time in correct format
              </ng-container>
            </div>
            <div
              class="tw-text-alert-800 sml-form-error"
              *ngIf="ItemDates?.errors"
            >
              <ng-container *ngIf="ItemDates?.errors?.['startTimeRequired']">
                Please enter Start time.
              </ng-container>
              <ng-container *ngIf="ItemDates?.errors?.['endTimeRequired']">
                Please enter End time.
              </ng-container>
             
            </div>
          </div>
        </ng-container>
        <div class="sml-control-group tw-col-span-1 max-md:tw-col-span-2" *ngIf="isRegistrationItem"
      [ngClass]="{'tablet:!tw-col-span-2':  ItemDates.get('eventType')?.value ===
            dateLevelEnum['Multi Day Event'],
      
      }">
        <label for="timeZone" class="sml-label">Event Time Zone <sup class="tw-text-alert-800">*</sup></label>
        <sml-search-dropdown #searchDropdownComponent formControlName="timeZone"  [position]="'bottom'" [items]="timeZones" (controlTouched)="onControlTouched()" (controlDirty)="onControlDirty()" [placeholder]="'Select Time Zone'" [isInvalid]="control['timeZone'].invalid && (control['timeZone'].dirty || control['timeZone'].touched)" [isRegistrationItem]="isRegistrationItem"></sml-search-dropdown>
        <div class="sml-form-error" *ngIf="control['timeZone'].invalid && (control['timeZone'].dirty || control['timeZone'].touched)">
          <p *ngIf="control['timeZone'].errors?.['required']" class="tw-text-alert-800">
           This field is mandatory.
          </p>
        </div>
      </div>
      </div>
      <div class="tw-text-start">
        <button
          type="button"
          smlButton="link"
          size="sm"
          color="primary"
          (click)="onClear()"
        >
        {{isRegistrationItem ? 'Clear Dates' : 'Clear'}}
        </button>
      </div>
    </ng-container>
  </div>
</div>
